// 80 mm / 3-inch rolls can expose a smaller printable area through the driver.
// Keep both safety margins INSIDE the available width, never add them to it or
// translate the document. A 72 mm area leaves 60 mm for content. A narrower
// driver area still shrinks normally; paper height/cutter remain driver-owned.
export const THERMAL_PRINT_MAX_WIDTH = '72mm';
export const THERMAL_PRINT_PADDING_CSS = 'padding:0 6mm!important;';
// Bills use a compact inset; do not silently change report/ledger geometry.
export const BILL_PRINT_SIDE_MM = 2;
export const BILL_PRINT_PADDING_CSS = `padding:0 ${BILL_PRINT_SIDE_MM}mm!important;`;
export const THERMAL_PRINT_PAGE_CSS = `html,body,#root{box-sizing:border-box!important;margin:0!important;padding:0!important;width:100%!important;max-width:${THERMAL_PRINT_MAX_WIDTH}!important;height:auto!important;min-height:0!important;overflow:visible!important;background:#fff!important}body{display:block!important}`;
